import { Component, OnInit } from '@angular/core';

/**
 * One capability tile on the Enterprise page. `note` is the small qualifier some
 * of them carry (e.g. indemnity, which depends on the contract).
 */
interface EnterpriseFeature {
    title: string;
    note?: string;
}

@Component({
  selector: 'molla-enterprise',
  templateUrl: './enterprise.component.html',
  styleUrls: ['./enterprise.component.scss']
})
export class EnterpriseComponent implements OnInit {

    /**
     * The capability grid. Held as data rather than nine near-identical blocks of
     * markup, so the order and wording are edited in one place.
     */
    readonly features: EnterpriseFeature[] = [
        { title: 'Stock licensing' },
        { title: 'AI creation' },
        { title: 'Team access' },
        { title: 'Custom commercial plans' },
        { title: 'Dedicated Relationship Manager' },
        { title: 'Research & sourcing' },
        { title: 'Professional enhancement' },
        { title: 'Compliance support' },
        { title: 'Enhanced protection / indemnity', note: 'where contractually applicable' }
    ];

  constructor() { }

  ngOnInit(): void {
  }

    trackByTitle(_: number, item: EnterpriseFeature): string {
        return item?.title;
    }

}
